module.exports = __webpack_public_path__ + "img/cardbg-2.c694ff5d.jpeg";